import { render, staticRenderFns } from "./taxEmpLsit.vue?vue&type=template&id=a0d2d42e&scoped=true&"
import script from "./taxEmpLsit.vue?vue&type=script&lang=js&"
export * from "./taxEmpLsit.vue?vue&type=script&lang=js&"
import style0 from "./taxEmpLsit.vue?vue&type=style&index=0&id=a0d2d42e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d2d42e",
  null
  
)

export default component.exports